export default __webpack_public_path__ + "static/media/LightBlue0001.24b34014.png";